import type {ModelStatusPayload} from '@core/hooks/modelStatusTypes'

/** The avatar menu's "Your model" row. */
export function modelMenuLabel(status: ModelStatusPayload | null): string {
    if (!status) return 'Your model · train yours'
    if (status.status === 'ready') {
        return status.delivered ? 'Your model · ready' : 'Your model · ready — see its first looks'
    }
    if (status.status === 'failed') return 'Your model · needs attention'
    return `Your model · training${status.percent != null ? ` ${status.percent}%` : ''}`
}
